import css from 'component/DotDivider/DotDivider.module.scss'

export function DotDivider() {
  return <div className={css.divider} />
}
